interface ConsoleEntry {
	level: 'log' | 'warn' | 'error' | 'info'
	message: string
	timestamp: number
}

const MAX_ENTRIES = 50
const buffer: ConsoleEntry[] = []

export function initConsoleCapture() {
	const levels = ['log', 'warn', 'error', 'info'] as const

	for (const level of levels) {
		const original = console[level]
		console[level] = (...args: unknown[]) => {
			buffer.push({
				level,
				message: args
					.map(a => {
						try {
							return typeof a === 'string' ? a : JSON.stringify(a)
						} catch {
							return String(a)
						}
					})
					.join(' '),
				timestamp: Date.now(),
			})
			if (buffer.length > MAX_ENTRIES) {
				buffer.shift()
			}
			original.apply(console, args)
		}
	}

	// Capture uncaught errors
	window.addEventListener('error', e => {
		buffer.push({
			level: 'error',
			message: `${e.message} at ${e.filename}:${e.lineno}:${e.colno}`,
			timestamp: Date.now(),
		})
		if (buffer.length > MAX_ENTRIES) {
			buffer.shift()
		}
	})

	// Capture unhandled promise rejections
	window.addEventListener('unhandledrejection', e => {
		buffer.push({
			level: 'error',
			message: `Unhandled rejection: ${e.reason}`,
			timestamp: Date.now(),
		})
		if (buffer.length > MAX_ENTRIES) {
			buffer.shift()
		}
	})
}

export function getConsoleLogs(): ConsoleEntry[] {
	return [...buffer]
}
